import { AbstractControl, ValidationErrors } from "@angular/forms";
/**
 * @description
 * This method is used to validate if two formcontrols have the same value
 * @param {string} controlName (first formcontrol name)
 * @param {string} matchingControlName (second formcontrol name)
 * @returns {null | ValidationErrors}
 */
export function matchValidator(controlName: string, matchingControlName: string) {
    return (ctrl: AbstractControl): null | ValidationErrors => {
        if (!ctrl.get(controlName) || !ctrl.get(matchingControlName)) {
            return {
                confirmEqual: 'Invalid control name'
            };
        }
        const control = ctrl.get(controlName)!.value;
        const matchingControl = ctrl.get(matchingControlName)!.value;

        return control === matchingControl ? null : {
            confirmEqual:
            {
                controlName: control,
                matchingControlName: matchingControl
            }
        };
    };
}